export enum MarkerType {
  DOT = 'dot',
  BIG_DOT = 'bigDot',
  PIN = 'pin',
  MAUSOLEUM = 'mausoleum',
  SECTION = 'section',
}
